import { observable, action, computed } from 'mobx';
import { groupBy } from 'lodash';
import { Cases } from 'api';

class CaseStore {
  @observable.ref caseData = {};

  @observable fetchState;

  anketId;

  caseNumber;

  @computed
  get sides() {
    return groupBy(this.caseData.sides, 'side');
  }

  @action.bound
  async getCase(anketId, caseNumber) {
    if (this.anketId === anketId && this.caseNumber === caseNumber) {
      return;
    }

    this.fetchState = 'pending';

    try {
      const response = await Cases.getCase(anketId, caseNumber);
      this.caseData = response.data;
      this.fetchState = 'fulfilled';
      this.anketId = anketId;
      this.caseNumber = caseNumber;
    } catch (e) {
      this.fetchState = 'rejected';
    }
  }
}

const caseStore = new CaseStore();

export default caseStore;
